import React, { useEffect, useState } from "react";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonItem,
  IonLabel,
  IonList,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonSpinner,
  IonIcon,
  IonBadge,
} from "@ionic/react";
import { useLocation, useParams, useHistory } from "react-router";
import {
  personCircle,
  calendar,
  timeOutline,
  peopleCircle,
  checkmarkCircle,
  closeCircle,
  pencil,
  arrowBack,
} from "ionicons/icons";
import axios from "axios";
import { baseUrl, requestID } from "../../../common/utils";
import { formattedDate, formattedDateTime } from "../../../common/utils_t";

/* interface ElectionDetails {
  id: string;
  title: string;
  description: string;
  startDate: string;
  endDate: string;
  status: string;
  positions: Position[];
  totalVoters: number;
  totalVotesCast: number;
}
 */
 

 

interface ElectionDetails {
  id: string;
  title: string;
  description: string;
  startDate: string;
  endDate: string;
  status: string;
  no_of_positions: string;
  totalVoters: number;
  totalVotesCast: number;
}

interface Position {
  id: string;
  name: string;
  description: string;
  aspirants: Aspirant[];
  position_id: string;
}

interface Aspirant {
  id: string;
  name: string;
  bio: string;
  photoUrl: string;
  voteCount: number;
  position_id: string;
  firstName: string;
}

const ManageElection: React.FC = () => {
  //const { id } = useParams<{ id: string }>();
  const [election, setElection] = useState<ElectionDetails | null>(null);
  const [electionVotes, setElectionVotes] = useState({});
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const history = useHistory();

  const location = useLocation();
  const dataId = location.state || {};
  const id = dataId?.state?.dataId;
  console.log("Election ID:", id);

   const [form, setForm] = useState({
    election_id: '',
    aspirant_name: '',
    position_id: '',
    aspirant_user_id: '',
  });
 
  const [positions, setPositions] = useState<Position[]>([]);
  const [aspirants, setAspirants] = useState<Aspirant[]>([]);
  

  //const history = useHistory();

 


  // useEffect(() => {
  //   if (id) {
  //       console.log('Election ID:', id); // Log the ID to the console
  //   } else {
  //       console.log('No ID found in state.');
  //     }
  // }, [id]);

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  

  const fetchElectionDetails = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("election_id", id);
      console.log(formData);
      axios
        .post(baseUrl() + "elections/getElectionDetail", formData, config)
        .then((response) => {
          console.log({ response });
          if (response.data && response.data.data) {
            setElection(response.data.data);
            setElectionVotes(response.data.data2);
            setError(null);
          } else {
            setError("No election data found.");
          }
        })
        .catch((err) => {
          console.error("Error fetching election details:", err);
          setError("Failed to load election details. Please try again.");
        });
    } finally {
      setLoading(false);
    }
  };

    useEffect(() => {
    fetchElectionDetails();
    fetchElectionPositions();
    fetchAspirants(id);
  }, [id]);


  const fetchAspirants = (electionId: string) => {
    // if (!electionId.trim()) {
    //   setAspirants([]);
    //   return;
    // }

    setLoading(true);
    
    const formData = new FormData();
    formData.append('requestID', requestID());
    formData.append('election_id', electionId);
    formData.append('position_id', form.position_id);

    axios.post(baseUrl() + 'elections/getAspirants', formData, config)
      .then(res => {
        console.log(res);
        
        if (res.data && res.data.data) {
          setAspirants(res.data.data);
          
        } else {
          setAspirants([]);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch aspirants:', err);
        setLoading(false);
        setAspirants([]);
      });
  };

 /*  const fetchElectionDetails = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("election_id", id);
console.log(formData);
      axios.post(baseUrl() + "elections/getElectionDetail", formData, config)
        .then((response) => {
          console.log(response.data);
          if (response.data && response.data.data) {
            setElection(response.data.data);
            setError(null);
          } else {
            setError("No election data found.");
          }
        })
        .catch((err) => {
          console.error("Error fetching election details:", err);
          setError("Failed to load election details. Please try again.");
        });
    } finally {
      setLoading(false);
    }
  }; */

  const fetchElectionPositions = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("election_id", id);
console.log(formData);
      axios.post(baseUrl() + "elections/getPositions", formData, config)
        .then((response) => {
          console.log(response.data);
          if (response.data && response.data.data) {
            setPositions(response.data.data);
            setError(null);
          } else {
            setError("No election data found...");
          }
        })
        .catch((err) => {
          console.error("Error fetching election position", err);
          setError("Failed to load election position. Please try again.");
        });
    } finally {
      setLoading(false);
    }
  };


  //     console.log( response);

  //     if (response.data && response.data.data) {
  //       setElection(response.data.data);
  //       setError(null);
  //     } else {
  //       setError('No election data found.');
  //     }
  //   } catch (err) {
  //     console.error('Error fetching election details:', err);
  //     setError('Failed to load election details. Please try again.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleStartElection = async () => {
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("election_id", id);
      formData.append("status", election.status);

      const response = await axios.post(
        baseUrl() + "elections/startElection",
        formData,
        config
      );

      console.log({ response });
      fetchElectionDetails();
    } catch (err) {
      console.error("Error starting election:", err);
      setError("Failed to start election. Please try again.");
    }
  };

  // const handleEndElection = async () => {
  //   try {
  //     const formData = new FormData();
  //     formData.append('requestID', requestID());
  //     formData.append('electionID', id);

  //     const response = await axios.post(baseUrl() + 'elections/endElection', formData, config);

  //     if (response.data && response.data.status === 'success') {
  //       fetchElectionDetails();
  //     } else {
  //       setError(response.data.message || 'Failed to end election');
  //     }
  //   } catch (err) {
  //     console.error('Error ending election:', err);
  //     setError('Failed to end election. Please try again.');
  //   }
  // };

  const getStatusBadge = (status: string) => {
    switch (status.toLowerCase()) {
      case "active":
        return <IonBadge color="success">Active</IonBadge>;
      case "pending":
        return <IonBadge color="warning">Pending</IonBadge>;
      case "completed":
        return <IonBadge color="primary">Completed</IonBadge>;
      default:
        return <IonBadge color="medium">{status}</IonBadge>;
    }
  };

  // function handleStartElection(
  //   event: MouseEvent<HTMLIonButtonElement, MouseEvent>
  // ): void {
  //   throw new Error("Function not implemented.");
  // }

  function handleEndElection(
    event: MouseEvent<HTMLIonButtonElement, MouseEvent>
  ): void {
    throw new Error("Function not implemented.");
  }

  function onManage(id: any): void {
    history.push(`/folder/viewElectionResults/${id}`, {
      state: { dataId: id },
    });
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Manage Election</IonTitle>
          <IonButtons slot="end">
            <IonButton routerLink="/folder/election/setup">
              <IonIcon icon={arrowBack} />
              Back
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        {loading ? (
          <div className="ion-text-center ion-padding">
            <IonSpinner name="circular" />
            <p>Loading election details...</p>
          </div>
        ) : error ? (
          <div className="ion-text-center ion-padding">
            <p className="ion-color-danger">{error}</p>
            <IonButton routerLink="/folder/election/setup">
              Return to Elections..33 {error}
            </IonButton>
          </div>
        ) : election ? (
          <>
            {/* Election Info */}
            <IonCard>
              <IonCardHeader>
                <IonCardTitle>{election.title}</IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                <p>{election.description}</p>

                <IonGrid>
                  <IonRow>
                    <IonCol size="6">
                      <IonItem lines="none">
                        <IonIcon icon={calendar} slot="start" />
                        <IonLabel>
                          <h2>Start Date</h2>
                          <p>
                            {formattedDateTime(election?.start_data)}{" "}
                            {/* {election?.start_data} */}
                          </p>
                        </IonLabel>
                      </IonItem>
                    </IonCol>
                    <IonCol size="6">
                      <IonItem lines="none">
                        <IonIcon icon={timeOutline} slot="start" />
                        <IonLabel>
                          <h2>End Date</h2>
                          <p>{formattedDateTime(election?.end_data)}</p>
                        </IonLabel>
                      </IonItem>
                    </IonCol>
                  </IonRow>

                  <IonRow>
                    <IonCol size="6">
                      <IonItem lines="none">
                        <IonIcon icon={peopleCircle} slot="start" />
                        <IonLabel>
                          <h2>Total Voters</h2>
                          <p>{electionVotes.total_votes}</p>
                        </IonLabel>
                      </IonItem>
                    </IonCol>
                    <IonCol size="6">
                      <IonItem lines="none">
                        <IonIcon icon={checkmarkCircle} slot="start" />
                        <IonLabel>
                          <h2>Votes Cast</h2>
                          <p>{electionVotes.percentage_votes}</p>
                        </IonLabel>
                      </IonItem>
                    </IonCol>
                  </IonRow>

                  <IonRow>
                    <IonCol size="12">
                      <IonItem lines="none">
                        <IonLabel>
                          <h2>Status</h2>
                          {getStatusBadge(
                            election.status == "1" ? "active" : "inactive"
                          )}
                        </IonLabel>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                </IonGrid>

                {/* Action Buttons */}
                <div className="ion-padding-top">
                  {election.status == "0" ? (
                    <IonButton
                      expand="block"
                      color="success"
                      disabled={
                        election.status.toLowerCase() === "active" ||
                        election.status.toLowerCase() === "completed"
                      }
                      onClick={handleStartElection}
                    >
                      <IonIcon icon={checkmarkCircle} slot="start" />
                      Start Election
                    </IonButton>
                  ) : (
                    <>
                      <IonButton
                        expand="block"
                        color="danger"
                        disabled={election.status.toLowerCase() == "0"}
                        onClick={handleStartElection}
                      >
                        <IonIcon icon={closeCircle} slot="start" />
                        End Election
                      </IonButton>
                    </>
                  )}

                  <IonButton
                    expand="block"
                    onClick={() => onManage(id)}
                    // routerLink={`/folder/viewElectionResults/${id}`}
                    color="primary"
                  >
                    View Results
                  </IonButton>
                </div>
              </IonCardContent>
            </IonCard>

            {/* Positions & Aspirants */}
             <IonCard>
              <IonCardHeader>
                <IonCardTitle>Positions & Aspirants</IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                {Number(election.no_of_positions) > 0 ? (
                  positions.map((position) => (
                    <div key={position.id} className="ion-margin-bottom">
                      <IonItem lines="full" color="light">
                        <IonLabel>
                          <h2>{position.name}</h2>
                          {/* <p>{position.description}</p> */}
                        </IonLabel>
                        <IonButton
                          slot="end"
                          size="small"
                          routerLink={`/folder/addPosition?edit=${position.id}&electionId=${id}`}
                        >
                          <IonIcon icon={pencil} />
                        </IonButton>
                      </IonItem>
                      {aspirants.map((aspirant) => (
                        aspirant.position_id === position.position_id && (
                          <IonItem key={aspirant.id}>
                            <IonIcon icon={personCircle} slot="start" />
                            <IonLabel>
                              <h3>{aspirant.firstName}</h3>
                              <p>{aspirant.bio}</p>
                            </IonLabel>
                            <IonBadge slot="end">
                              {aspirant.voteCount} votes
                            </IonBadge>
                          </IonItem>
                        )
                      ))}
                      {/* <IonList>
                        {position.aspirants && position.aspirants.length > 0 ? (
                          position.aspirants.map((aspirant) => (
                            <IonItem key={aspirant.id}>
                              <IonIcon icon={personCircle} slot="start" />
                              <IonLabel>
                                <h3>{aspirant.name}</h3>
                                <p>{aspirant.bio}</p>
                              </IonLabel>
                              <IonBadge slot="end">
                                {aspirant.voteCount} votes
                              </IonBadge>
                            </IonItem>
                          ))
                        ) : (
                          <p className="ion-text-center ion-padding">
                            No aspirants for this position.
                          </p>
                        )}
                      </IonList> */}

                      <div className="ion-text-center ion-padding">
                        <IonButton
                          size="small"
                          routerLink={`/folder/addAspirant?positionId=${position.position_id}&electionId=${id}`}
                        >
                          Add Aspirant
                        </IonButton>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="ion-text-center ion-padding">
                    No positions added to this election yet.
                  </p>
                )}

                <div className="ion-padding-top ion-text-center">
                  <IonButton
                    routerLink={`/folder/addPosition?electionId=${id}`}
                  >
                    Add New Position
                  </IonButton>
                </div>
              </IonCardContent>
            </IonCard>
          </>
        ) : (
          <div className="ion-text-center ion-padding">
            <p>Election not found.</p>
            <IonButton routerLink="/folder/election/setup">
              Return to Elections....12
            </IonButton>
          </div>
        )}
      </IonContent>
    </IonPage>
  );
};

export default ManageElection;
